import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../../utils/styleUtils';

import styles from './FormPage.scss';


function FormPage({children, className}) {

    return (
        <form className={styleUtils.toClasses(styles.formPageContainer, className, 'container')}>
            {children}
        </form>
    );
}


FormPage.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string
};


export default FormPage;
